<!--
  A Bulma-styled text input field allowing multiple text items to be added
-->
<template>
  <div class="fieldWrapper field">
    <div style="display:flex">
      <label v-if="label" class="label">{{ label }}</label>
      <slot name="top"/>
    </div>

    <p v-if="description" class="mb-2">{{description}}</p>

    <div class="control">
      <div class="inputRow">
        <input
          ref="inputElem"
          class="input" type="text"
          v-model.trim="newItem"
          @keyup.enter="addItem()"
        />

        <button type="submit" value="Save" class="button is-link is-small ml-1" @click="addItem()">
            <i class="fas fa-plus mr-2"/>
            Add
        </button>
      </div>

      <div class="mt-2 is-flex is-flex-wrap-wrap">
          <div v-for="(item, idx) in items" :key="idx" class="mr-2">
              <span class="tag is-light is-rounded has-text-weight-bold" :class="{'is-large':size=='large'}">
                  <i v-if="icon" class="fas fa-lg mr-3" :class="icon"/>
                  <div class="badgeLabel">{{ item }}</div>
                  <span class="delete ml-2" :class="{'is-large':size=='large'}" role="button" @click="removeItem(idx)">(x)</span>
              </span>
          </div>

          <!-- default message if there are no location names-->
          <div v-if="items.length == 0" class="list-group-item">{{ noneMessage || 'None specified.' }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

const props = defineProps<{
  modelValue: string[],
  label?: string,
  description?: string,
  noneMessage?: string,
  icon?: string,
  trimmed?: boolean,
  size?: "large"|"small"
}>();

const newItem = ref<string>("");
const items = ref<string[]>([]);

// Event for two-way binding
const emit = defineEmits(['update:modelValue'])

const addItem = () => {
  if (props.trimmed) {
    newItem.value = newItem.value.trim();
  }
  
  if (newItem.value.length == 0) return;
  if (!items.value) { 
    items.value = [newItem.value];
  } else {
    items.value.push(newItem.value);
  }
  newItem.value = "";
  onInput();
}

const removeItem = (i: number) => {
  items.value.splice(i,1);
  onInput();
}

const onInput = () => {
  emit('update:modelValue', items.value);
};

onMounted(() => {
  items.value = [...props.modelValue];
})
</script>

<style scoped>
.inputRow {
  display: flex;
  gap: 1rem;
}
</style>